<template>
  <v-dialog v-model="show" max-width="500px" scrollable persistent>
    <v-card elevation="8" class="rounded-lg">
      <v-card-title class="py-3 px-4">
        <div>
          <span class="text-h6 font-weight-bold">Reasignación de paquete</span>
          <v-divider class="my-2"></v-divider>
          <span class="text-subtitle-1">Selecciona el paquete que deseas reasignar</span>
        </div>
      </v-card-title>
      <v-card-text class="modal-content">
        <v-container class="pa-0">
          <v-form ref="form">
            <v-row>
              <v-col cols="12" md="12">
                <v-autocomplete outlined label="Selecciona paquete" prepend-inner-icon="mdi-package-variant-closed"
                  dense v-model="packageFound" :search-input.sync="searchPackage" :items="packages" hide-no-data
                  :item-text="formatItemText" clearable return-object :loading="loadingPackages"
                  :rules="validation('paquete')" class="my-3" :disabled="isLoading" />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row class="d-flex justify-space-between align-center">
            <v-col cols="6">
              <v-btn color="grey lighten-1" dark block @click="show = false" :disabled="isLoading" elevate-on-hover
                class="py-2">
                Cerrar
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn color="primary" dark block :loading="isLoading" elevate-on-hover class="py-2"
                @click="updatePackageInAnalysis">
                Actualizar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//Vuex
import { mapActions, mapState, mapMutations } from "vuex";
//validation
import { requiredValidation } from "@/helpers/validations.js";
export default {
  data: () => ({
    isLoading: false,
    packageFound: null,
    searchPackage: null,
    packages: [],
    loadingPackages: false,
  }),
  props: {
    value: Boolean,
  },
  async mounted() {
    this.searchPackage = "";
  },
  computed: {
    ...mapState("reception", ["currentSelection"]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...mapActions("reception", ["updatePackage"]),
    ...mapActions("laboratory", ["getPackagesByName"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    validation(name) {
      return requiredValidation(name);
    },
    formatItemText(item) {
      return `${item.name} - ${item.laboratoryName}`;
    },
    async updatePackageInAnalysis() {
      if (this.$refs.form.validate()) {
        try {
          this.isLoading = true;
          let payload = {
            analysisId: this.currentSelection._id,
            packageId: this.packageFound._id,
          };
          let response = await this.updatePackage(payload);
          if (!response) throw Error("Empty response");
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: `Paquete actualizado`,
            timeout: 3000,
          });
          this.$emit("hide");
        } catch (error) {
          console.log(error);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: `Algo salió mal. Error: ${error.message}`,
            timeout: 5000,
          });
        }
        this.isLoading = false;
      }
    },
  },
  watch: {
    async searchPackage(value) {
      try {
        this.loadingPackages = true;
        const req = await this.getPackagesByName({ name: value });

        if (req.error) throw req;

        this.packages = req.packages;
      } catch (error) {
        console.error(error);
      }
      this.loadingPackages = false;
    },
  },
};
</script>

<style scoped>
.v-dialog {
  max-height: 90vh;
  /* Limita la altura del modal al 90% de la pantalla */
}

.modal-content {
  max-height: 300px;
  /* Limita la altura del contenido del modal */
  overflow-y: auto;
  /* Habilita el scroll solo dentro del contenido si es necesario */
}

.v-card {
  max-width: 500px;
  /* Asegura que el ancho del modal esté limitado */
}

.v-btn {
  transition: all 0.3s ease;
}

.v-btn:hover {
  transform: scale(1.02);
}

.v-divider {
  background-color: #e0e0e0;
}

@media (max-width: 600px) {
  .v-card-title {
    text-align: center;
  }

  .v-row {
    justify-content: center;
  }
}
</style>
